import React, { useState } from 'react';

export default function JsonViewer({ data, label, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);

  if (data === null || data === undefined) return null;

  const text = typeof data === 'string' ? data : JSON.stringify(data, null, 2);

  return (
    <div className="ednl-json-viewer">
      <button className="ednl-json-viewer__toggle" onClick={() => setOpen(!open)}>
        {open ? '▾' : '▸'} {label || 'JSON'}
      </button>
      {open && <pre className="ednl-json-viewer__pre">{text}</pre>}
    </div>
  );
}
